import React from "react";
import { MegaMenuDrawer, MegaMenu } from "@muchbetteradventures/styleguide";
import trackEvent from "../tracking";

var handleMenuItemLinkClick = function handleMenuItemLinkClick(clickEvent, menuItem) {
  clickEvent.preventDefault();
  var nextUrl = menuItem.url;
  var nextUrlTarget = menuItem.target || "_self";
  var trackingProps = {
    menuItem: menuItem
  };
  var trackingEvent = "Menu Item Click";
  trackEvent(trackingEvent, trackingProps, nextUrl, nextUrlTarget);
};

var customerHelpButtonConfig = {
  title: "Contact Us",
  url: "https://help.muchbetteradventures.com/contact-us",
  target: "_blank"
};

var NavDrawer = function NavDrawer(_ref) {
  var open = _ref.open,
      onClose = _ref.onClose,
      menu = _ref.menu;
  return /*#__PURE__*/React.createElement(MegaMenuDrawer, {
    disablePortal: true,
    keepMounted: true,
    offsetTopBelowMenuBar: true,
    open: open,
    onClose: onClose
  }, /*#__PURE__*/React.createElement(MegaMenu, {
    customerHelpButton: customerHelpButtonConfig,
    menu: menu,
    onMenuItemClick: handleMenuItemLinkClick
  }));
};

export default NavDrawer;